import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Components
import HomePage from './pages/HomePage';
import CoursePage from './pages/CoursePage';
import PersistentChatBot from './components/Chat/PersistentChatBot';
import GitHubActionsSidebar from './components/GitHubActions/GitHubActionsSidebar';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/course/:courseId" element={<CoursePage />} />
        </Routes>
        
        {/* Persistent Chat Bot */}
        <PersistentChatBot />
        
        {/* GitHub Actions Sidebar */}
        <GitHubActionsSidebar />
      </Router>
    </AuthProvider>
  );
}

export default App;